export const SENSOR_MEASURES_FETCH_STARTED = 'SENSOR_MEASURES_FETCH_STARTED';
export const SENSOR_MEASURES_FETCH_COMPLETED = 'SENSOR_MEASURES_FETCH_COMPLETED';
export const SENSOR_MEASURES_FETCH_FAILED = 'SENSOR_MEASURES_FETCH_FAILED';

export const SENSOR_MEASURES_CLEAR = 'SENSOR_MEASURES_CLEAR';
